import { createModel } from "~~/package/utils/ModelUtil";
import Model from "~~/package/mapper/Model";
import { AdvancedAssessmentType } from "~~/package/mapper/proSkillAssure/model/AdvancedAssessmentType";

export class ProSkillManagerSetModel extends Model {
  constructor(
    public trackId: number = 0,
    public trackTitle: string | null = null,
    public trackLevelTitle: string | null = null,
    public setLearningTime: number = 0,
    public setCount: number = 0,
    public assessmentContentType: AdvancedAssessmentType = AdvancedAssessmentType.CORE
  ) {
    super();
  }

  public static create(model: Partial<ProSkillManagerSetModel>): ProSkillManagerSetModel {
    return createModel<ProSkillManagerSetModel>(ProSkillManagerSetModel, {
      ...model
    });
  }
}
